import { session } from "./session";

export interface LevelCat { icon: string; name: string; nameM: string; }
export interface LevelDef { min: number; icon: string; name: string; nameM: string; cat: number; }

const LEVEL_CATS: LevelCat[] = [
  { icon: "🐣", name: "Nováčik", nameM: "Nováčik" },
  { icon: "🌱", name: "Zelenáč", nameM: "Zelenáč" },
  { icon: "🔥", name: "Zapálenec", nameM: "Zapálenec" },
  { icon: "💪", name: "Vytrvalec", nameM: "Vytrvalec" },
  { icon: "⚙️", name: "Stroj", nameM: "Stroj" },
  { icon: "🛡️", name: "Bojovník", nameM: "Bojovník" },
  { icon: "🦾", name: "Majster", nameM: "Majster" },
  { icon: "🧠", name: "Guru", nameM: "Guru" },
  { icon: "🏆", name: "Šampión", nameM: "Šampión" },
  { icon: "👑", name: "Legenda", nameM: "Legenda" },
  { icon: "🌟", name: "Vesmírny", nameM: "Vesmírny" },
  { icon: "⚡", name: "Super Godlike", nameM: "Super Godlike" },
];
// v29 — Level 0 „Deň nula" is a virtual pre-level for a brand-new user (0–11 b). The first
// splnený návyk (5–20 b podľa náročnosti) väčšinou hneď dá Level 1 „Totálne newbie"; pri
// jednoduchom návyku (5 b) treba dva. Deň nula is NOT part of the 60-level grid; levelIndex
// returns -1 for it and getLevel maps that to this object.
const DEN_NULA: LevelDef = { min: 0, icon: "🥚", name: "Deň nula", nameM: "Deň nula", cat: -1 };
// v30 — mriežka sa rozšírila z 50 na **60 úrovní** (12 tierov × 5 úrovní) s novými menami od
// majiteľky. **Prahy Lv1–Lv50 sú NEZMENENÉ** oproti v29; pribudlo len Lv51–Lv60 (vzorec 12·n²
// zaokrúhlený na desiatky, strop 43 200 b). Zmenil sa jediný názov tieru: „Mýtický" → „Vesmírny".
// Rodové tvary: `nameM` = mužský, `name` = ženský (viď `gname`). Kde je meno rodovo neutrálne,
// platí `name === nameM`.
// Prahy MUSIA sedieť s `app.py` TIER_MINS (minimum prvej úrovne každého tieru) a `LEVEL_ICON`
// v `web/src/LevelIcons.tsx` musí mať kľúč pre 0…60 (stráži to `levels.test.ts`).
const LEVELS: LevelDef[] = [
  // ── 🐣 Nováčik (Lv 1–5) ──
  { min: 12, icon: "🐣", name: "Totálne newbie", nameM: "Totálne newbie", cat: 0 },
  { min: 50, icon: "🎮", name: "Mačkanie tlačidiel", nameM: "Mačkanie tlačidiel", cat: 0 },
  { min: 110, icon: "📗", name: "Tutoriálová úroveň", nameM: "Tutoriálová úroveň", cat: 0 },
  { min: 190, icon: "👶", name: "Ešte sa učí chodiť", nameM: "Ešte sa učí chodiť", cat: 0 },
  { min: 300, icon: "✊", name: "Prvá prekážka zdolaná", nameM: "Prvá prekážka zdolaná", cat: 0 },
  // ── 🌱 Zelenáč (Lv 6–10) ──
  { min: 430, icon: "🌱", name: "Prvé výhonky", nameM: "Prvé výhonky", cat: 1 },
  { min: 590, icon: "🌿", name: "Klíčenie", nameM: "Klíčenie", cat: 1 },
  { min: 770, icon: "🪴", name: "Silnejšie korene", nameM: "Silnejšie korene", cat: 1 },
  { min: 970, icon: "🌳", name: "Rastie každým dňom", nameM: "Rastie každým dňom", cat: 1 },
  // POZN. pre majiteľku: „Rozkvitá" NIE JE tvoje meno — doplnil ho agent, lebo zoznam mien pre
  // tier Zelenáč mal len 4 položky a tier potrebuje 5. Pokojne prepíš.
  { min: 1200, icon: "🌸", name: "Rozkvitá", nameM: "Rozkvitá", cat: 1 },
  // ── 🔥 Zapálenec (Lv 11–15) ──
  { min: 1452, icon: "✨", name: "Prvá iskra", nameM: "Prvá iskra", cat: 2 },
  { min: 1730, icon: "🕯️", name: "Sviečka", nameM: "Sviečka", cat: 2 },
  { min: 2028, icon: "🔥", name: "Rozhorený plameň", nameM: "Rozhorený plameň", cat: 2 },
  { min: 2352, icon: "☀️", name: "Slobodná vatra", nameM: "Slobodná vatra", cat: 2 },
  { min: 2700, icon: "⛽", name: "Organizovaný požiar", nameM: "Organizovaný požiar", cat: 2 },
  // ── 💪 Vytrvalec (Lv 16–20) ──
  { min: 3072, icon: "👟", name: "Prvé kilometre", nameM: "Prvé kilometre", cat: 3 },
  { min: 3468, icon: "🐂", name: "Neuhýba z cesty", nameM: "Neuhýba z cesty", cat: 3 },
  { min: 3888, icon: "🏃", name: "Na dlhé trate", nameM: "Na dlhé trate", cat: 3 },
  { min: 4332, icon: "🏅", name: "Maratónkyňa", nameM: "Maratónec", cat: 3 },
  { min: 4800, icon: "⛰️", name: "Ultra bežkyňa", nameM: "Ultra bežec", cat: 3 },
  // ── ⚙️ Stroj (Lv 21–25) ──
  { min: 5292, icon: "⚙️", name: "Prvé ozubené koleso", nameM: "Prvé ozubené koleso", cat: 4 },
  { min: 5808, icon: "🔧", name: "Funkčný motor", nameM: "Funkčný motor", cat: 4 },
  { min: 6348, icon: "🤖", name: "Beží na výkon", nameM: "Beží na výkon", cat: 4 },
  { min: 6912, icon: "🧭", name: "Autopilotka", nameM: "Autopilot", cat: 4 },
  { min: 7500, icon: "♾️", name: "Perpetuum mobile", nameM: "Perpetuum mobile", cat: 4 },
  // ── 🛡️ Bojovník (Lv 26–30) ──
  { min: 8112, icon: "🎓", name: "Výcvik dokončený", nameM: "Výcvik dokončený", cat: 5 },
  { min: 8748, icon: "🛡️", name: "V plnej zbroji", nameM: "V plnej zbroji", cat: 5 },
  { min: 9408, icon: "⚔️", name: "V nasadení", nameM: "V nasadení", cat: 5 },
  { min: 10092, icon: "🔱", name: "Gladiátorka", nameM: "Gladiátor", cat: 5 },
  { min: 10800, icon: "🎖️", name: "Veteránka bojísk", nameM: "Veterán bojísk", cat: 5 },
  // ── 🦾 Majster (Lv 31–35) ──
  { min: 11532, icon: "📖", name: "Učeníčka", nameM: "Učeň", cat: 6 },
  { min: 12288, icon: "🖊️", name: "Pomocníčka majsterky", nameM: "Pomocník majstra", cat: 6 },
  { min: 13068, icon: "🥷", name: "Majsterka", nameM: "Majster", cat: 6 },
  { min: 13872, icon: "🎻", name: "Virtuózka", nameM: "Virtuóz", cat: 6 },
  { min: 14700, icon: "♟️", name: "Veľmajsterka", nameM: "Veľmajster", cat: 6 },
  // ── 🧠 Guru (Lv 36–40) ──
  { min: 15552, icon: "💡", name: "Začína chápať", nameM: "Začína chápať", cat: 7 },
  { min: 16428, icon: "🧠", name: "Hlboké poznanie", nameM: "Hlboké poznanie", cat: 7 },
  { min: 17328, icon: "🦉", name: "Múdrosť", nameM: "Múdrosť", cat: 7 },
  { min: 18252, icon: "🧘", name: "Vnútorný vhľad", nameM: "Vnútorný vhľad", cat: 7 },
  { min: 19200, icon: "🌅", name: "Osvietenie", nameM: "Osvietenie", cat: 7 },
  // ── 🏆 Šampión (Lv 41–45) ──
  { min: 20172, icon: "💪", name: "Maká v úzadí", nameM: "Maká v úzadí", cat: 8 },
  { min: 21168, icon: "🥈", name: "Prvé pódium", nameM: "Prvé pódium", cat: 8 },
  { min: 22188, icon: "🥇", name: "Medailová forma", nameM: "Medailová forma", cat: 8 },
  { min: 23232, icon: "📈", name: "Rekordy padajú", nameM: "Rekordy padajú", cat: 8 },
  { min: 24300, icon: "🏛️", name: "Sieň slávy", nameM: "Sieň slávy", cat: 8 },
  // ── 👑 Legenda (Lv 46–50) ──
  { min: 25392, icon: "👥", name: "Rozpoznateľná", nameM: "Rozpoznateľný", cat: 9 },
  { min: 26508, icon: "⭐", name: "Známe meno", nameM: "Známe meno", cat: 9 },
  { min: 27648, icon: "🦁", name: "Živá legenda", nameM: "Živá legenda", cat: 9 },
  { min: 28812, icon: "👑", name: "Mýtus medzi ľuďmi", nameM: "Mýtus medzi ľuďmi", cat: 9 },
  { min: 30000, icon: "🌓", name: "Polobohyňa", nameM: "Poloboh", cat: 9 },
  // ── 🌟 Vesmírny (Lv 51–55) ── (nové úrovne, vzorec 12·n² zaokrúhlený na desiatky)
  { min: 31210, icon: "🌟", name: "Mýtus ožíva", nameM: "Mýtus ožíva", cat: 10 },
  { min: 32450, icon: "🛸", name: "Mimozemšťanka", nameM: "Mimozemšťan", cat: 10 },
  { min: 33710, icon: "🌌", name: "Medzi hviezdami", nameM: "Medzi hviezdami", cat: 10 },
  { min: 34990, icon: "☄️", name: "Kozmické rozmery", nameM: "Kozmické rozmery", cat: 10 },
  { min: 36300, icon: "💥", name: "Veľký tresk", nameM: "Veľký tresk", cat: 10 },
  // ── ⚡ Super Godlike (Lv 56–60) ──
  { min: 37630, icon: "⚡", name: "Godlike", nameM: "Godlike", cat: 11 },
  { min: 38990, icon: "⏳", name: "Nad časom", nameM: "Nad časom", cat: 11 },
  { min: 40370, icon: "🕳️", name: "Nad priestorom", nameM: "Nad priestorom", cat: 11 },
  { min: 41770, icon: "♾️", name: "Nesmrteľnosť", nameM: "Nesmrteľnosť", cat: 11 },
  { min: 43200, icon: "🦄", name: "Transcendencia", nameM: "Transcendencia", cat: 11 },
];
// -1 = Level 0 „Deň nula" (below the first real level, i.e. under 12 b)
const levelIndex = (p: number): number => { let i = -1; for (let k = 0; k < LEVELS.length; k++) if (p >= LEVELS[k].min) i = k; return i; };
const getLevel = (p: number): LevelDef => { const i = levelIndex(p); return i < 0 ? DEN_NULA : LEVELS[i]; };
const nextLevel = (p: number): LevelDef | null => LEVELS.find((l) => l.min > p) || null;
// v30 — časť mien má rodové tvary (Maratónec/Maratónkyňa…): `nameM` pre mužov, `name` pre ostatných
const gname = (lvl: LevelDef | null | undefined): string => (lvl ? (session.gender === "m" ? lvl.nameM : lvl.name) : "");

export { LEVEL_CATS, LEVELS, DEN_NULA, levelIndex, getLevel, nextLevel, gname };
